import { action, payload } from 'ts-action'
import { IShift } from 'models/Shift'
import { IError, IPayload } from 'models/Global'
import { IFavorite } from 'models/Favorite'

export const UpshifterMyShiftsFetching = action(
  'UpshifterMyShiftsFetching',
  payload<boolean>(),
)

export const GetUpshifterMyShifts = action(
  'GetUpshifterMyShifts',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterMyShiftsWithoutConcat = action(
  'GetUpshifterMyShiftsWithoutConcat',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterMyShiftsErrors = action(
  'GetUpshifterMyShiftsErrors',
  payload<IError>(),
)

export const ClearUpshifterMyShiftsReducer = action(
  'ClearUpshifterMyShiftsReducer',
)

export const UpshifterMyShiftsSetHasMore = action(
  'UpshifterMyShiftsSetHasMore',
  payload<boolean>(),
)

export const UpshifterMyShiftsUnfavoriteBusiness = action(
  'UpshifterMyShiftsUnfavoriteBusiness',
  payload<number>(),
)

export const UpshifterMyShiftsFavoriteBusiness = action(
  'UpshifterMyShiftsFavoriteBusiness',
  payload<IFavorite>(),
)

export const UpshifterMyShiftsUpdateShift = action(
  'UpshifterMyShiftsUpdateShift',
  payload<IShift>(),
)

export const UpshifterMyShiftsRemoveShift = action(
  'UpshifterMyShiftsRemoveShift',
  payload<number>(),
)
